export default Object.freeze( {
	top: [
		{
			href: { name: "front" },
			icon: "home",
			title: "Home"
		},
		{
			href: { name: "apps" },
			icon: "widgets",
			title: "Apps",
			items: [
				{
					href: { name: "cubicFeetCalculator" },
					title: "Cubic Feet Calculator"
				},
				{
					href: { name: "marginCalculator" },
					title: "Margin Calculator"
				},
				{
					href: { name: "sealantCalculator" },
					title: "Sealant Calculator"
				}
			]
		},
		{
			href: { name: "company" },
			icon: "store",
			title: "Company",
			items: [
				{
					href: { name: "bonus" },
					title: "Bonus"
				},
				{
					href: { name: "facilityMaintenance" },
					title: "Facility Maintenance",
					items: [
						{
							href: { name: "facilityMaintenanceContacts" },
							title: "Contacts"
						},
						{
							href: { name: "facilityMaintenanceVendors" },
							title: "Vendors"
						},
						{
							href: { name: "facilityMaintenanceVendorTypes" },
							title: "Vendor Categories"
						},
						{
							href: { name: "facilityMaintenanceWorkOrders" },
							title: "Work Orders"
						}
					]
				},
				{
					href: { name: "locations" },
					title: "Locations"
				},
				{
					href: { name: "vto" },
					title: "Vision / Traction Organizer"
				},
				{
					href: { name: "thirdPartyServices" },
					title: "3rd Party Services"
				},
				{
					dialog: "pdf",
					href: "/employee-handbook.pdf",
					target: "_blank",
					title: "Employee Handbook"
				},
				{
					href: "https://www.paycomonline.net/v4/ee/web.php/app/login",
					target: "_blank",
					title: "Paycom"
				}
			]
		},
		{
			href: { name: "counterSales" },
			icon: "shopping_cart",
			title: "Counter Sales",
			items: [
				{
					href: { name: "salesLeads" },
					title: "Sales Leads"
				},
				{
					href: { name: "specSheets" },
					title: "Spec Sheets"
				}
			]
		},
		{
			href: { name: "outsideSales" },
			icon: "monetization_on",
			title: "Outside Sales",
			items: [
				{
					href: { name: "customers" },
					title: "Customers"
				},
				{
					href: { name: "salesmen" },
					title: "Salesmen"
				}
			]
		},
		{
			href: { name: "pricingHelpList" },
			icon: "description",
			title: "Pricing Help & Logins"
		},
		{
			href: { name: "safety" },
			icon: "traffic",
			title: "Safety",
			items: [

				// {
				// 	href: { name: "safetyAccidents" },
				// 	title: "Accident / Incident Reports"
				// },
				{
					href: { name: "safetyEmployeeInjuries" },
					title: "Employee Injury Reports"
				},
				{
					href: { name: "safetyNearMisses" },
					title: "Near Miss Reports"
				}
			]
		},
		{
			href: { name: "serviceCenter" },
			icon: "map",
			title: "Service Center",
			items: [
				{
					href: { name: "serviceMap" },
					title: "Service Map"
				},
				{
					href: { name: "serviceTypes" },
					title: "Status Types"
				}
			]
		},
		{
			href: { name: "warehouse" },
			icon: "all_inbox",
			title: "Warehouse",
			items: [
				{
					href: { name: "carriers" },
					title: "Carriers"
				},
				{
					href: { name: "outboundFreightList" },
					title: "Outbound Freight"
				},
				{
					href: { name: "warehouseReports" },
					title: "Reports"
				}
			]
		},
		{
			href: { name: "yard" },
			icon: "local_shipping",
			title: "Yard",
			items: [
				{
					href: { name: "yardDrivers" },
					title: "Drivers"
				},
				{
					href: { name: "yardHub" },
					title: "Hub"
				},
				{
					href: { name: "yardReports" },
					title: "Reports"
				},
				{
					href: { name: "yardSchedules" },
					title: "Schedules"
				},
				{
					href: { name: "yardTripCostEstimator" },
					title: "Trip Cost Estimator"
				},
				{
					href: { name: "yardTrips" },
					title: "Trips"
				},
				{
					href: { name: "yardTrucks" },
					title: "Trucks"
				}
			]
		}
	],

	bottom: [
		{ divider: true },
		{
			href: { name: "account" },
			icon: "account_circle",
			title: "My Account"
		},
		{
			href: "http://ksrticket.com",
			icon: "help",
			target: "_blank",
			title: "IT Help Desk"
		},
		{
			href: { name: "logout" },
			icon: "power_settings_new",
			title: "Log Out"
		}
	]
} );
